import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  label?: string;
  tone?: "light" | "dark";
};
export function Countdown({
  label = "The special offer ends in:",
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === "dark";
  const units = [{
    value: hours,
    unit: "Hours"
  }, {
    value: minutes,
    unit: "Min"
  }, {
    value: seconds,
    unit: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-93" data-mp="3h18weufg2681">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-brand-cyan" : "text-navy-800"}`} data-id="element-94" data-mp="323ydj00h1y2a">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="373kp750nj68z" />
        {label}
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-96" data-mp="10c3crffr7dyu">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-97" data-mp="15by6dqqwyhnl" data-mpi={i}>
            {i > 0 && <span className={`pt-3 text-3xl font-black ${dark ? "text-white/60" : "text-navy-900"}`} data-id="element-98" data-mp="15an0nldwqztu">:</span>}
            <div className="flex flex-col items-center" data-id="element-99" data-mp="xz3oa76eved0">
              <span className={`grid h-[68px] w-[68px] place-items-center rounded-2xl text-[32px] font-black tabular-nums md:h-20 md:w-20 md:text-4xl ${dark ? "bg-white text-navy-900" : "bg-navy-900 text-white"}`} data-id="element-100" data-mp="t12057u4oouo">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-bold uppercase tracking-wider ${dark ? "text-white/70" : "text-muted"}`} data-id="element-101" data-mp="f2kgpmb99yik">{u.unit}</span>
            </div>
          </React.Fragment>)}
      </div>
      <p className={`mt-3 rounded-full px-3 py-1 text-xs font-extrabold uppercase tracking-wider ${dark ? "bg-alert text-white" : "bg-alert-light text-alert"}`} data-id="element-102" data-mp="o0w7boc4gwb0">
        Limited launch price
      </p>
    </div>;
}